import axios from "axios";
import Vue from "vue";
import i18n from '@/i18n/index';
const lang = i18n.locale;
const successCode = [200, 0, 103];
const codeForValue = {
  101: 'orderNotExistText',
  102: 'orderInvalidText',
  104: 'orderInvalidText',
};
const config = require("../../config");
let {baseUrl} = config[process.env.NODE_ENV]
// const currentBaseUrl = process.env.NODE_ENV==='production'?mockUrl+baseUrl:mockUrl+baseUrl;
const currentBaseUrl = baseUrl;
const service = axios.create({
  baseURL:currentBaseUrl,
  timeout: 3000,
  headers: {
    'Content-Type': 'application/json',  // 默认 Content-Type 为 json
    'Accept-Language': localStorage.getItem('lang')
  }
});

service.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = localStorage.getItem('lang')
    if (config.url.includes('upload') || config.isFormData) {
      config.headers['Content-Type'] = 'multipart/form-data'
      console.log(config, 'config')
    }
    // if(config)
    return config;
  },
  (error) => {
    Vue.prototype.$toast.fail('error');
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (res) => {
    if (res.status !== 200) {
      Vue.prototype.$toast.fail(res.data.msg);
      return Promise.reject(res);
    } else if (res.status === 200 && !successCode.includes(res.data.code)) {
      Vue.prototype.$toast.fail(res.data.msg);
      return Promise.reject(res);
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log(error.response.data.msg,'error.response.data.msg')
    Vue.prototype.$toast.fail(error.response.data.msg);
    return Promise.reject(error);
  }
);

export default service;
